import { Box, Stack } from "@mui/material"

import { useQuery } from "@tanstack/react-query"

import { OrderRow } from "./OrderRow"
import { getActiveOrder } from "@/api/agents-api"
import { ErrorBoundary } from "@/components/ErrorBoundary"
import { LoadingSkeletons } from "@/components/LoadingSkeletons"

export function SingleAgent(props: { entityId: string }) {
  const { entityId } = props

  const { data: order } = useQuery({
    queryKey: [`active_order`, entityId],
    enabled: !!entityId,
    queryFn: async () => {
      if (!entityId) throw new Error("Params missing")

      const result = await getActiveOrder(entityId)
      console.log("onSingleAgent", result)
      return result
    },
  })

  return (
    <Box>
      {!order ? (
        <LoadingSkeletons />
      ) : (
        <Stack gap={1}>
          <ErrorBoundary key={order.id} fallback={<>Something went wrong</>}>
            <OrderRow order={order} singleAgentView />
          </ErrorBoundary>
        </Stack>
      )}
    </Box>
  )
}
